(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('#image-map').each(function () {
		var wrap = $(this);
		var nav = wrap.find('nav');

		// Open on click
		nav.find('a').on('click', function (e) {
			e.preventDefault();

			// Remove previously active
			wrap.find('article.active').removeClass('active');
			nav.find('a.active').removeClass('active');

			// Add this
			$(this).addClass('active');
			$($(this).attr('href')).addClass('active');
		});

		// Activate on mouseover/out
	/*	nav.find('a').on('mouseover', function () {
			wrap.addClass('active');
			$(this).addClass('active');
			$($(this).attr('href')).addClass('active');
		}).on('mouseout', function () {
			wrap.removeClass('active');
			$(this).removeClass('active');
			$($(this).attr('href')).removeClass('active');
		}); */

		// Close on deactivate click
		wrap.find('a.deactivate').on('click', function (e) {
			e.preventDefault();

			wrap.removeClass('active');
			nav.find('a.active').removeClass('active');
			wrap.find('article.active').removeClass('active');
		});
	});
})();
